import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import NewsletterForm from '../../../../components/newsletters/newsletters_form';
import {
  updatePostUpUserAction,
  updatePostUpEmailAction
} from '../../../../../redux/actions/newsletters/async_newsletters_preferences_page_actions';
import {
  newsletterPreferencesChange,
  newsletterPreferencesChangeRadio,
  prepareEmailFieldForChange
} from '../../../../../redux/action_creators/newsletters_preferences_page_action_creators';
import newsletterPreferencesPageData from './newsletters_preferences_page_data';

class NewslettersPreferencesPage extends Component {
  constructor() {
    super();
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleNewslettersRadioUpdate = this.handleNewslettersRadioUpdate.bind(
      this
    );
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeEmailClick = this.handleChangeEmailClick.bind(this);
    this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
    this.handleChangeEmailSubmit = this.handleChangeEmailSubmit.bind(this);
    this.handleUnsubscribeAll = this.handleUnsubscribeAll.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.state = {
      emailFormError: ''
    };
  }

  setFocus(ref) {
    this.emailInput = ref;
  }

  handleCheckboxChange(e) {
    const { target } = e;
    const id = Number(target.name);
    this.props.actions.newsletterPreferencesChange({
      id
    });
  }

  handleNewslettersRadioUpdate(e) {
    const { target } = e;
    const selectedListId = Number(target.value);
    const radioSet = target.name.split(',').map(str => Number(str));
    this.props.actions.newsletterPreferencesChangeRadio({
      selectedListId,
      radioSet
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const newsletterPrefPageData = get(
      this.props,
      'newslettersPreferencesPage'
    );
    const userData = get(newsletterPrefPageData, 'data');
    const userId = get(userData, 'userId');
    const email = get(userData, 'email');
    const subscribe = get(newsletterPrefPageData, 'subscribe');
    const unsubscribe = get(newsletterPrefPageData, 'unsubscribe');
    const currUrl = get(this.props, 'config.navHistory[0]');

    if (subscribe.length === 0 && unsubscribe.length === 0) {
      return null;
    }

    const params = {
      userId,
      email,
      lists: subscribe,
      unsubscribe,
      sourceDescription: currUrl
    };

    this.props.actions.updatePostUpUserAction(params, this.props.config);
    return true;
  }

  handleUnsubscribeAll(e) {
    e.preventDefault();
    const newsletterPrefPageData = get(
      this.props,
      'newslettersPreferencesPage'
    );
    const userData = get(newsletterPrefPageData, 'data');
    const userId = get(userData, 'userId');
    const email = get(userData, 'email');
    const lists = get(userData, 'lists', []);
    const params = {
      userId,
      email,
      unsubscribe: lists
    };
    this.props.actions.updatePostUpUserAction(params, this.props.config);
    return true;
  }

  handleChangeEmailClick() {
    this.props.actions.prepareEmailFieldForChange();
    this.setState(
      {
        email: ''
      },
      function setStateCallback() {
        this.emailInput.focus();
      }
    );
  }

  detectCorrectEmail(email) {
    return typeof email === 'string'
      ? /[^\s@]+@[^\s@]+\.[^\s@]+/.test(email)
      : null;
  }

  handleEmailInputChange(e) {
    this.setState(
      {
        email: e.target.value
      },
      () => {
        const isValidEmail = this.detectCorrectEmail(this.state.email);

        this.setState({
          emailFormError: isValidEmail ? false : 'Invalid email address'
        });
      }
    );
  }

  handleChangeEmailSubmit(e) {
    e.preventDefault();
    const newsletterPreferencesPage = get(
      this.props,
      'newslettersPreferencesPage.data'
    );
    const newEmail = this.state.email;
    if (newEmail !== newsletterPreferencesPage.email) {
      this.props.actions.updatePostUpEmailAction(
        {
          email: newEmail,
          userId: newsletterPreferencesPage.userId
        },
        this.props.config
      );
    } else {
      this.props.actions.prepareEmailFieldForChange();
    }
  }

  render() {
    if (this.props.newslettersPreferencesPage.error) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.newslettersPreferencesPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
    const email = get(this.props, 'newslettersPreferencesPage.data.email');
    const masterLookup = get(
      this.props,
      'newslettersPreferencesPage.masterLookup'
    );
    const subscribedTo = get(
      this.props,
      'newslettersPreferencesPage.data.lists',
      []
    );

    const currentNewsletterSelectionState = this.props
      .newslettersPreferencesPage.allNewslettersSelected;

    return (
      <div className="container">
        <NewsletterForm
          hed="Email Preference Center"
          dek="Indicate your email preferences below. Once you have made your changes to your information, save your preferences."
          sections={newsletterPreferencesPageData}
          listsDictionary={masterLookup}
          filter={true}
          handleEmailUpdate={this.handleEmailInputChange}
          emailValue={
            typeof this.state.email === 'string' ? this.state.email : email
          }
          placeholder={email}
          handleNewslettersUpdate={this.handleCheckboxChange}
          handleNewslettersRadioUpdate={this.handleNewslettersRadioUpdate}
          buttonText="Change Email"
          state={currentNewsletterSelectionState}
          setFocus={this.setFocus}
          toggleInputOn={this.handleChangeEmailClick}
          emailFormError={this.state.emailFormError}
          emailUpdateSuccessMessage={
            this.props.newslettersPreferencesPage.emailUpdateSuccessMessage
          }
          emailUpdateMessageError={
            this.props.newslettersPreferencesPage.emailUpdateMessageError
          }
          subscribedToIds={subscribedTo}
          alreadyUsed={{}}
          emailEditable={this.props.newslettersPreferencesPage.emailEditable}
          stickySubmit={true}
          handleSignupSubmit={this.handleChangeEmailSubmit}
          handleStickySubmit={this.handleSubmit}
          handleUnsubscribeAll={this.handleUnsubscribeAll}
          stickyMessage={
            this.props.newslettersPreferencesPage
              .subscriptionUpdateSuccessMessage
          }
        />
      </div>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    newslettersPreferencesPage: state.newslettersPreferencesPage || {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        newsletterPreferencesChange,
        updatePostUpEmailAction,
        newsletterPreferencesChangeRadio,
        updatePostUpUserAction,
        prepareEmailFieldForChange
      },
      dispatch
    )
  };
}

NewslettersPreferencesPage.propTypes = {
  config: PropTypes.shape({}).isRequired,
  actions: PropTypes.shape({
    newsletterPreferencesChange: PropTypes.func,
    updatePostUpUserAction: PropTypes.func,
    prepareEmailFieldForChange: PropTypes.func,
    updatePostUpEmailAction: PropTypes.func,
    newsletterPreferencesChangeRadio: PropTypes.func
  }).isRequired,
  newslettersPreferencesPage: PropTypes.shape({
    isLoading: PropTypes.bool,
    allNewslettersSelected: PropTypes.shape({}),
    data: PropTypes.shape({
      lists: PropTypes.arrayOf(PropTypes.number),
      email: PropTypes.string,
      userId: PropTypes.string
    }),
    subscribe: PropTypes.arrayOf(PropTypes.number),
    unsubscribe: PropTypes.arrayOf(PropTypes.number),
    emailEditable: PropTypes.bool.isRequired,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    emailUpdateMessageError: PropTypes.string,
    emailUpdateSuccessMessage: PropTypes.string,
    subscriptionUpdateSuccessMessage: PropTypes.string
  }).isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(
  NewslettersPreferencesPage
);



// WEBPACK FOOTER //
// ./src/views/containers/pages/newsletters/newsletters_preferences/newsletters_preferences_page.js